/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CurrentlyActiveResponse } from '../models/currently-active-response';
import { deleteFeV1SchedulationsId } from '../fn/schedulations/delete-fe-v-1-schedulations-id';
import { DeleteFeV1SchedulationsId$Params } from '../fn/schedulations/delete-fe-v-1-schedulations-id';
import { getFeV1Schedulations$Json } from '../fn/schedulations/get-fe-v-1-schedulations-json';
import { GetFeV1Schedulations$Json$Params } from '../fn/schedulations/get-fe-v-1-schedulations-json';
import { getFeV1Schedulations$Plain } from '../fn/schedulations/get-fe-v-1-schedulations-plain';
import { GetFeV1Schedulations$Plain$Params } from '../fn/schedulations/get-fe-v-1-schedulations-plain';
import { getFeV1SchedulationsCurrentlyActive$Json } from '../fn/schedulations/get-fe-v-1-schedulations-currently-active-json';
import { GetFeV1SchedulationsCurrentlyActive$Json$Params } from '../fn/schedulations/get-fe-v-1-schedulations-currently-active-json';
import { getFeV1SchedulationsCurrentlyActive$Plain } from '../fn/schedulations/get-fe-v-1-schedulations-currently-active-plain';
import { GetFeV1SchedulationsCurrentlyActive$Plain$Params } from '../fn/schedulations/get-fe-v-1-schedulations-currently-active-plain';
import { getFeV1SchedulationsId$Json } from '../fn/schedulations/get-fe-v-1-schedulations-id-json';
import { GetFeV1SchedulationsId$Json$Params } from '../fn/schedulations/get-fe-v-1-schedulations-id-json';
import { getFeV1SchedulationsId$Plain } from '../fn/schedulations/get-fe-v-1-schedulations-id-plain';
import { GetFeV1SchedulationsId$Plain$Params } from '../fn/schedulations/get-fe-v-1-schedulations-id-plain';
import { postFeV1Schedulations$Json } from '../fn/schedulations/post-fe-v-1-schedulations-json';
import { PostFeV1Schedulations$Json$Params } from '../fn/schedulations/post-fe-v-1-schedulations-json';
import { postFeV1Schedulations$Plain } from '../fn/schedulations/post-fe-v-1-schedulations-plain';
import { PostFeV1Schedulations$Plain$Params } from '../fn/schedulations/post-fe-v-1-schedulations-plain';
import { postFeV1SchedulationsIdLock } from '../fn/schedulations/post-fe-v-1-schedulations-id-lock';
import { PostFeV1SchedulationsIdLock$Params } from '../fn/schedulations/post-fe-v-1-schedulations-id-lock';
import { postFeV1SchedulationsIdUnlock } from '../fn/schedulations/post-fe-v-1-schedulations-id-unlock';
import { PostFeV1SchedulationsIdUnlock$Params } from '../fn/schedulations/post-fe-v-1-schedulations-id-unlock';
import { putFeV1SchedulationsId$Json } from '../fn/schedulations/put-fe-v-1-schedulations-id-json';
import { PutFeV1SchedulationsId$Json$Params } from '../fn/schedulations/put-fe-v-1-schedulations-id-json';
import { putFeV1SchedulationsId$Plain } from '../fn/schedulations/put-fe-v-1-schedulations-id-plain';
import { PutFeV1SchedulationsId$Plain$Params } from '../fn/schedulations/put-fe-v-1-schedulations-id-plain';
import { SchedulationResponse } from '../models/schedulation-response';
import { SchedulationResponseListResponse } from '../models/schedulation-response-list-response';

@Injectable({ providedIn: 'root' })
export class SchedulationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFeV1Schedulations()` */
  static readonly GetFeV1SchedulationsPath = '/v1/schedulations';

  /**
   * Gets all schedulations.
   *
   * Gets all schedulations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1Schedulations$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Schedulations$Plain$Response(params?: GetFeV1Schedulations$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponseListResponse>> {
    return getFeV1Schedulations$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all schedulations.
   *
   * Gets all schedulations.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1Schedulations$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Schedulations$Plain(params?: GetFeV1Schedulations$Plain$Params, context?: HttpContext): Observable<SchedulationResponseListResponse> {
    return this.getFeV1Schedulations$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchedulationResponseListResponse>): SchedulationResponseListResponse => r.body)
    );
  }

  /**
   * Gets all schedulations.
   *
   * Gets all schedulations.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1Schedulations$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Schedulations$Json$Response(params?: GetFeV1Schedulations$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponseListResponse>> {
    return getFeV1Schedulations$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all schedulations.
   *
   * Gets all schedulations.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1Schedulations$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Schedulations$Json(params?: GetFeV1Schedulations$Json$Params, context?: HttpContext): Observable<SchedulationResponseListResponse> {
    return this.getFeV1Schedulations$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchedulationResponseListResponse>): SchedulationResponseListResponse => r.body)
    );
  }

  /** Path part for operation `postFeV1Schedulations()` */
  static readonly PostFeV1SchedulationsPath = '/v1/schedulations';

  /**
   * Creates a new schedulation.
   *
   * Creates a new schedulation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1Schedulations$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Schedulations$Plain$Response(params?: PostFeV1Schedulations$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponse>> {
    return postFeV1Schedulations$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new schedulation.
   *
   * Creates a new schedulation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1Schedulations$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Schedulations$Plain(params?: PostFeV1Schedulations$Plain$Params, context?: HttpContext): Observable<SchedulationResponse> {
    return this.postFeV1Schedulations$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchedulationResponse>): SchedulationResponse => r.body)
    );
  }

  /**
   * Creates a new schedulation.
   *
   * Creates a new schedulation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1Schedulations$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Schedulations$Json$Response(params?: PostFeV1Schedulations$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponse>> {
    return postFeV1Schedulations$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new schedulation.
   *
   * Creates a new schedulation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1Schedulations$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postFeV1Schedulations$Json(params?: PostFeV1Schedulations$Json$Params, context?: HttpContext): Observable<SchedulationResponse> {
    return this.postFeV1Schedulations$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchedulationResponse>): SchedulationResponse => r.body)
    );
  }

  /** Path part for operation `getFeV1SchedulationsCurrentlyActive()` */
  static readonly GetFeV1SchedulationsCurrentlyActivePath = '/v1/schedulations/currently-active';

  /**
   * Gets the currently active schedulation.
   *
   * Gets the currently active schedulation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1SchedulationsCurrentlyActive$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1SchedulationsCurrentlyActive$Plain$Response(params?: GetFeV1SchedulationsCurrentlyActive$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentlyActiveResponse>> {
    return getFeV1SchedulationsCurrentlyActive$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the currently active schedulation.
   *
   * Gets the currently active schedulation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1SchedulationsCurrentlyActive$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1SchedulationsCurrentlyActive$Plain(params?: GetFeV1SchedulationsCurrentlyActive$Plain$Params, context?: HttpContext): Observable<CurrentlyActiveResponse> {
    return this.getFeV1SchedulationsCurrentlyActive$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrentlyActiveResponse>): CurrentlyActiveResponse => r.body)
    );
  }

  /**
   * Gets the currently active schedulation.
   *
   * Gets the currently active schedulation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1SchedulationsCurrentlyActive$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1SchedulationsCurrentlyActive$Json$Response(params?: GetFeV1SchedulationsCurrentlyActive$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentlyActiveResponse>> {
    return getFeV1SchedulationsCurrentlyActive$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the currently active schedulation.
   *
   * Gets the currently active schedulation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1SchedulationsCurrentlyActive$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1SchedulationsCurrentlyActive$Json(params?: GetFeV1SchedulationsCurrentlyActive$Json$Params, context?: HttpContext): Observable<CurrentlyActiveResponse> {
    return this.getFeV1SchedulationsCurrentlyActive$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CurrentlyActiveResponse>): CurrentlyActiveResponse => r.body)
    );
  }

  /** Path part for operation `getFeV1SchedulationsId()` */
  static readonly GetFeV1SchedulationsIdPath = '/v1/schedulations/{id}';

  /**
   * Gets a schedulation by its hashed ID.
   *
   * Gets a schedulation by its hashed ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1SchedulationsId$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1SchedulationsId$Plain$Response(params: GetFeV1SchedulationsId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponse>> {
    return getFeV1SchedulationsId$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a schedulation by its hashed ID.
   *
   * Gets a schedulation by its hashed ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1SchedulationsId$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1SchedulationsId$Plain(params: GetFeV1SchedulationsId$Plain$Params, context?: HttpContext): Observable<SchedulationResponse> {
    return this.getFeV1SchedulationsId$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchedulationResponse>): SchedulationResponse => r.body)
    );
  }

  /**
   * Gets a schedulation by its hashed ID.
   *
   * Gets a schedulation by its hashed ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1SchedulationsId$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1SchedulationsId$Json$Response(params: GetFeV1SchedulationsId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponse>> {
    return getFeV1SchedulationsId$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets a schedulation by its hashed ID.
   *
   * Gets a schedulation by its hashed ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1SchedulationsId$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1SchedulationsId$Json(params: GetFeV1SchedulationsId$Json$Params, context?: HttpContext): Observable<SchedulationResponse> {
    return this.getFeV1SchedulationsId$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchedulationResponse>): SchedulationResponse => r.body)
    );
  }

  /** Path part for operation `putFeV1SchedulationsId()` */
  static readonly PutFeV1SchedulationsIdPath = '/v1/schedulations/{id}';

  /**
   * Updates an existing schedulation.
   *
   * Updates an existing schedulation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putFeV1SchedulationsId$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1SchedulationsId$Plain$Response(params: PutFeV1SchedulationsId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponse>> {
    return putFeV1SchedulationsId$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing schedulation.
   *
   * Updates an existing schedulation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putFeV1SchedulationsId$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1SchedulationsId$Plain(params: PutFeV1SchedulationsId$Plain$Params, context?: HttpContext): Observable<SchedulationResponse> {
    return this.putFeV1SchedulationsId$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchedulationResponse>): SchedulationResponse => r.body)
    );
  }

  /**
   * Updates an existing schedulation.
   *
   * Updates an existing schedulation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putFeV1SchedulationsId$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1SchedulationsId$Json$Response(params: PutFeV1SchedulationsId$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulationResponse>> {
    return putFeV1SchedulationsId$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing schedulation.
   *
   * Updates an existing schedulation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putFeV1SchedulationsId$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putFeV1SchedulationsId$Json(params: PutFeV1SchedulationsId$Json$Params, context?: HttpContext): Observable<SchedulationResponse> {
    return this.putFeV1SchedulationsId$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SchedulationResponse>): SchedulationResponse => r.body)
    );
  }

  /** Path part for operation `deleteFeV1SchedulationsId()` */
  static readonly DeleteFeV1SchedulationsIdPath = '/v1/schedulations/{id}';

  /**
   * Deletes a schedulation.
   *
   * Deletes a schedulation.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFeV1SchedulationsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeV1SchedulationsId$Response(params: DeleteFeV1SchedulationsId$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteFeV1SchedulationsId(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a schedulation.
   *
   * Deletes a schedulation.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFeV1SchedulationsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFeV1SchedulationsId(params: DeleteFeV1SchedulationsId$Params, context?: HttpContext): Observable<void> {
    return this.deleteFeV1SchedulationsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postFeV1SchedulationsIdLock()` */
  static readonly PostFeV1SchedulationsIdLockPath = '/v1/schedulations/{id}/lock';

  /**
   * Locks a schedulation to prevent modifications.
   *
   * Locks a schedulation to prevent modifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1SchedulationsIdLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1SchedulationsIdLock$Response(params: PostFeV1SchedulationsIdLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postFeV1SchedulationsIdLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Locks a schedulation to prevent modifications.
   *
   * Locks a schedulation to prevent modifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1SchedulationsIdLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1SchedulationsIdLock(params: PostFeV1SchedulationsIdLock$Params, context?: HttpContext): Observable<void> {
    return this.postFeV1SchedulationsIdLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postFeV1SchedulationsIdUnlock()` */
  static readonly PostFeV1SchedulationsIdUnlockPath = '/v1/schedulations/{id}/unlock';

  /**
   * Unlocks a schedulation to allow modifications.
   *
   * Unlocks a schedulation to allow modifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postFeV1SchedulationsIdUnlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1SchedulationsIdUnlock$Response(params: PostFeV1SchedulationsIdUnlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postFeV1SchedulationsIdUnlock(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlocks a schedulation to allow modifications.
   *
   * Unlocks a schedulation to allow modifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postFeV1SchedulationsIdUnlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postFeV1SchedulationsIdUnlock(params: PostFeV1SchedulationsIdUnlock$Params, context?: HttpContext): Observable<void> {
    return this.postFeV1SchedulationsIdUnlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
